<template>
  <b-col class="text-center py-2" sm="12" md="4">
    <!-- second try -->
 
    <div class>
      <ul>
        <img :src="getImageUrl(product.Image)" style="max-height:300px;" v-b-modal.my-modal alt="" />
      </ul>
    </div>

    <div class="d-none">
      <h6 class="share-line">Share this item &nbsp;</h6>
      <font-awesome-icon
        class="share-line mx-1"
        icon="envelope"
      ></font-awesome-icon>
      <font-awesome-icon
        class="share-line mx-1"
        icon="paper-plane"
      ></font-awesome-icon>
    </div>

    <b-modal id="my-modal" ok-only hide-footer centered>
      <b-row class="justify-content-center">
        <img :src="getImageUrl(product.Image)" class="modal-img" />
      </b-row>
    </b-modal>
  </b-col>
</template>

<script>
export default {
  name: "ProductImages",
  props: ["product"],
  computed: {
    imgs() {
      return this.$store.getters.getProdImagesById(this.$route.params.id);
    },
  },
  data() {
    return {
      currentImg: "",
      showModal: false,
    };
  },
  methods: {
    setImg(img) {
      this.currentImg = img;
    },
  },
  created() {
    this.currentImg = this.imgs[0];
  },
};
</script>

<style scoped>
.modal-img {
  height: 100%;
  widows: 100%;
  overflow: auto;
}

ul {
  margin: 0;
  padding: 0;
}

ul li {
  list-style: none;
  height: 3rem;
  width: 3rem;
  margin: 5px;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;
  /* border: 1px solid lightgray; */
  border-radius: 5px;
}

ul li img {
  max-width: 100%;
  object-fit: contain;
  object-position: center center;
}

.slide {
  /* border: 1px solid lightgray; */
  border-radius: 5px;
}

.share-line {
  display: inline;
}

.slide img {
  max-width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: center center;
}
</style>
